// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"982":"product-detail","983":"products"}[chunkId] || chunkId) + "." + {"163":"aa2c8908","594":"22bc3bd0","862":"7fb623b4","982":"91c883f2","983":"745e7fe4"}[chunkId] + ".js";
};